import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { tagsApi } from 'API/tags-api/tags-api';
import { tagsQueryKeys } from 'hooks/queries/tags/tag-keys';
import { DEFAULT_QUERY_STALE_TIME } from 'queries/constant';
import { userSelector } from 'store/selectors/app-selectors';
import type { Tag } from '@placer-ui/types';

export const useGetTagsQuery = ({ enabled = true }: { enabled?: boolean } = {}) => {
    const user = useSelector(userSelector);

    return useQuery({
        queryKey: tagsQueryKeys.all,
        enabled,
        staleTime: DEFAULT_QUERY_STALE_TIME,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        queryFn: async () => {
            const tags = await tagsApi.getAllTags();

            const personalTags: Tag[] = [];
            const companyTags: Tag[] = [];

            tags.forEach((tag) => {
                if (tag.owner.username === user?.username) {
                    personalTags.push(tag);
                } else {
                    companyTags.push(tag);
                }
            });

            return {
                allTags: tags,
                personalTags,
                companyTags,
            };
        },
    });
};
